import actions from "./actions";

const {FETCH_USER_MONTHLY_ATTENDANCES,  FETCH_MONTH_DECLARATION_DATE, RESET_MONTH_DECLARATION_DATE } = actions;

const initState = {
    userMonthlyAttendances: {
        data: [],
    },
    monthDeclarationDate: { _id: null }
};

const UserMonthlyAttendanceReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_USER_MONTHLY_ATTENDANCES:
            return {
                ...state,
                userMonthlyAttendances: data
            };
        case FETCH_MONTH_DECLARATION_DATE:
            return {
                ...state,
                monthDeclarationDate: data._id ? data : initState.monthDeclarationDate,
            };
        case RESET_MONTH_DECLARATION_DATE:
            return {
                ...state,
                monthDeclarationDate: initState.monthDeclarationDate,
            };
        default:
            return state;
    }
};

export default UserMonthlyAttendanceReducer;
